const mutations = {
  RESET(state: PartnerStateObj) {
    state.active = {};
    state.list = [];
  },
  SET_ACTIVE(state: PartnerStateObj, partners: Partner) {
    state.active = partners;
  },
  PARTNERS_UPDATE(state: PartnerStateObj, partners: Partner[]) {
    state.list = partners;
  }
};

export default mutations;
